
import { Loader2, Brain } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const LoadingState = () => {
  return (
    <Card className="bg-secondary/50 backdrop-blur-lg border-2 border-primary/50">
      <CardContent className="p-8 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            <Brain className="h-16 w-16 text-primary" />
            <Loader2 className="h-6 w-6 text-primary animate-spin absolute -top-1 -right-1" />
          </div>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-white">Analyzing Performance Data</h3>
            <p className="text-gray-300">Processing multi-year performance insights...</p>
            <div className="flex justify-center space-x-2 mt-4">
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LoadingState;
